import _Grid from './Grid';
import _GridItem from './GridItem';

import './style';

export * from './type';

export const Grid = _Grid;

export const GridItem = _GridItem;

export default {
    Grid,
    GridItem
};
  
